import { c as _c } from "react/compiler-runtime";
import { Actions } from './actions';
import css from './docs.module.scss';
import { Links } from './links';
export function Docs() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={css.wrapper}><Actions /><Links /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}